import * as Action from "../action/run_monitor_alert_search.action"
import {RUN_MONITOR_ALERT_SEARCH_SET_PROJECT_TYPE} from "../action/run_monitor_alert_search.action";

const initState = {
    tableInfo: {
        isLoading: false,
        dataList: [],
        total: 0
    },
    treeId: null
}

/**
 * 告警查询reducer
 * @param state
 * @param action
 * @returns {{}}
 */
const alertSearchReducer = (state = initState, action) => {
    switch (action.type) {
        case Action.RUN_MONITOR_ALERT_SEARCH_TABLE_LIST_IS_LOADING: // 告警查询表格是否加载中
            return {...state, tableInfo: {...state.tableInfo, isLoading: action.isLoading}};
        case Action.RUN_MONITOR_ALERT_SEARCH_TABLE_LIST: // 告警查询表格
            return {...state, tableInfo: {...state.tableInfo, dataList: action.dataList, total: action.total}};
        case Action.RUN_MONITOR_ALERT_SEARCH_SET_PROJECT_TYPE: // 设置项目类型
            return {...state, treeId: action.treeId}
        default: return {...state};
    }
}

export default alertSearchReducer;
